function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M463.5,257.5c0,5.5-4.4,9.9-9.8,9.9H77.1c-5.4,0-9.8-4.6-9.8-9.9 c0-5.5,4.4-9.9,9.8-9.9h376.6C459.1,247.6,463.5,252.2,463.5,257.5z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M265.4,59.4c2.6,0,5.2,1,7.2,3.1c3.8,4,3.6,10.2-0.3,14l-190.6,181l190.6,181c4,3.8,4.1,10,0.3,14c-3.8,4-10.1,4.1-14,0.3 L52.9,257.5L258.6,62.1C260.5,60.3,262.9,59.4,265.4,59.4z"
});

var SvgArrowBack = function SvgArrowBack(props) {
  return React.createElement("svg", _extends({
    id: "Layer_2",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/arrow-back.ac7cfda7.svg";
export { SvgArrowBack as ReactComponent };